import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Loader2, PackageCheck } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { SiteHeader } from "@/components/SiteHeader";
import { Footer } from "@/components/BusinessSection";

const inp = "w-full border border-charcoal/20 bg-white px-3 py-2.5 text-sm outline-none focus:border-forest";

export default function Returns() {
  const [params] = useSearchParams();
  const [sid, setSid] = useState(params.get("order") || "");
  const [email, setEmail] = useState("");
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async () => {
    if (!sid.trim() || !email.trim()) { toast.error("Enter your order number and email"); return; }
    setBusy(true);
    try {
      await api.shopRequestReturn({ session_id: sid.trim(), email: email.trim(), reason: reason.trim() });
      setDone(true);
    } catch (e) { toast.error(e?.response?.data?.detail || "We couldn't submit that request"); }
    finally { setBusy(false); }
  };

  return (
    <div className="bg-paper min-h-screen" data-testid="returns-page">
      <SiteHeader />
      <div className="max-w-lg mx-auto px-5 py-16">
        <p className="hr-overline text-blaze">HomeRange Goods</p>
        <h1 className="font-serif text-4xl text-charcoal tracking-tight mt-2">Start a return</h1>
        {done ? (
          <div className="mt-8 bg-bone border border-saddle/20 p-6 text-center" data-testid="return-success">
            <PackageCheck size={36} className="mx-auto text-forest" />
            <p className="text-charcoal mt-3 font-medium">Your return request has been received.</p>
            <p className="text-charcoal/60 text-sm mt-1">Our team will review it and follow up by email with next steps.</p>
          </div>
        ) : (
          <>
            <p className="text-charcoal/60 mt-3 text-sm">Enter the order number from your confirmation email along with the email you used at checkout. Tell us why you'd like to return the item and we'll take it from there.</p>
            <div className="space-y-3 mt-6">
              <label className="block"><span className="text-xs uppercase tracking-wide text-charcoal/50">Order number</span>
                <input value={sid} onChange={(e) => setSid(e.target.value)} placeholder="cs_..." className={inp + " mt-1"} data-testid="return-order-input" /></label>
              <label className="block"><span className="text-xs uppercase tracking-wide text-charcoal/50">Email</span>
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" className={inp + " mt-1"} data-testid="return-email-input" /></label>
              <label className="block"><span className="text-xs uppercase tracking-wide text-charcoal/50">Reason (optional)</span>
                <textarea value={reason} onChange={(e) => setReason(e.target.value)} rows={4} placeholder="Tell us what went wrong or why you'd like to return it." className={inp + " mt-1"} data-testid="return-reason-input" /></label>
              <button onClick={submit} disabled={busy} className="w-full bg-forest text-bone py-3 font-semibold hover:bg-forest-2 transition-colors inline-flex items-center justify-center gap-2" data-testid="return-submit-btn">
                {busy && <Loader2 size={16} className="animate-spin" />} Request return
              </button>
            </div>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}
